import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {FaqComponent} from './faq/faq.component';
import {TermsCardComponent} from './terms/terms-card/terms-card.component';

const routes: Routes = [
    {
        path: '',
        redirectTo: 'terms',
        pathMatch: 'full'
    },
    {
        path: 'terms',
        component: TermsCardComponent
    },
    {
        path: 'faq',
        component: FaqComponent
    },
    {path: '**', redirectTo: 'terms'}
];

@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule]
})
export class AppRoutingModule {
}
